module.exports = __webpack_public_path__ + "img/brightscreen_300.d4df13c3.png";